import { apiClient } from './api';
import type {
    SystemToolSettings,
    SystemToolSettingsResponse,
    ToggleRoleResponse,
} from '../types/systemTools';

export const systemToolsService = {
    getSettings: async (): Promise<SystemToolSettings> => {
        const response = await apiClient.get<SystemToolSettingsResponse>('/api/system/tools');
        return response.data;
    },

    toggleRole: async (): Promise<ToggleRoleResponse> => {
        return apiClient.post<ToggleRoleResponse>('/api/system/tools/toggle-role', {});
    },
};
